// extracted by mini-css-extract-plugin
export default {"vacancies":"vacancies_vacancies__HxqlR","header":"vacancies_header__0NGus","carouselCard":"vacancies_carouselCard__OuJXv"};